var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isLoading
        ? _c("Spinner")
        : !!_vm.errorMessage.message
        ? _c("Message", {
            attrs: {
              message: _vm.errorMessage.message,
              icon: _vm.errorMessage.icon,
            },
          })
        : _c(
            "div",
            {
              class: _vm.showTable ? "card-item" : "",
              attrs: { id: "operation-table-full" },
            },
            [
              _vm.$i18n.locale === "pe"
                ? _c(
                    "div",
                    [
                      _c("Message", {
                        attrs: {
                          message: "",
                          icon: "coming_soon_cl.svg",
                          "as-card": true,
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { attrs: { "data-cy": "operation-table" } },
                    [
                      _c("b-field", { staticClass: "filter-fields" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "is-flex is-align-items-center is-justify-content-space-between is-flex-wrap-wrap-reverse",
                          },
                          [
                            _vm.showTable
                              ? _c(
                                  "b-dropdown",
                                  {
                                    attrs: {
                                      "data-cy": "select-columns",
                                      triggers: ["click"],
                                      "aria-role": "list",
                                      scrollable: "",
                                      "mobile-modal": false,
                                      "can-close": ["escape", "outside"],
                                      "close-on-click": false,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "trigger",
                                          fn: function ({ active }) {
                                            return [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    "icon-right": active
                                                      ? "angle-up"
                                                      : "angle-down",
                                                    size: "is-small",
                                                  },
                                                },
                                                [_vm._v("Seleccionar columnas")]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      27617218
                                    ),
                                  },
                                  _vm._l(
                                    _vm.tableHeaders.filter(
                                      (tableHeader) => tableHeader.selectable
                                    ),
                                    function (column, index) {
                                      return _c(
                                        "b-dropdown-item",
                                        { key: index, staticClass: "control" },
                                        [
                                          _c(
                                            "b-checkbox",
                                            {
                                              attrs: { size: "is-small" },
                                              model: {
                                                value: column.visible,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    column,
                                                    "visible",
                                                    $$v
                                                  )
                                                },
                                                expression: "column.visible",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(column.title) + " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "is-flex second-group-fields is-justify-content-flex-end is-align-items-center",
                                class: !_vm.showTable ? "no-table" : "",
                              },
                              [
                                _c(
                                  "b-field",
                                  { staticClass: "m-0" },
                                  [
                                    _c("b-datepicker", {
                                      attrs: {
                                        id: "datepicker-for-amortization-schedule",
                                        locale: _vm.localeForDatePicker,
                                        placeholder: _vm.$t(
                                          "dateForAmortizationSchedule"
                                        ),
                                        icon: "calendar-alt",
                                        size: "is-small",
                                        "trap-focus": "",
                                        "mobile-modal": false,
                                        "unselectable-dates":
                                          _vm.unselectableDates,
                                      },
                                      model: {
                                        value: _vm.date,
                                        callback: function ($$v) {
                                          _vm.date = $$v
                                        },
                                        expression: "date",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      "data-cy":
                                        "download-amortization-schedule",
                                      size: "is-small",
                                      rounded: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadAmortizationSchedule()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa-solid fa-download has-text-danger",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "download-btn-text" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("csvDevelopmentTable"))
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm.$i18n.locale === "br" && _vm.showTable
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "is-flex is-justify-content-space-between is-flex-wrap-wrap my-4",
                            },
                            [
                              _c(
                                "b-tag",
                                {
                                  staticClass: "my-1",
                                  attrs: {
                                    type: "is-light",
                                    icon: "circle-info",
                                    "data-cy": "inflation-warning",
                                    rounded: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.inflationWarning) + " "
                                  ),
                                ]
                              ),
                              _vm.missingPaymentsInformation
                                ? _c(
                                    "b-tag",
                                    {
                                      staticClass: "my-1",
                                      attrs: {
                                        type: "is-danger is-light",
                                        icon: "triangle-exclamation",
                                        "data-cy":
                                          "resume-company-operation-id",
                                        rounded: "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("missingPaymentsInformation")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isLoadingNewDate && _vm.showTable
                        ? _c("Spinner")
                        : _vm._e(),
                      !_vm.isLoadingNewDate && _vm.showTable
                        ? _c(
                            "b-table",
                            {
                              attrs: {
                                paginated: "",
                                hoverable: "",
                                "per-page": _vm.perPage,
                                "current-page": _vm.currentPage,
                                data: _vm.table,
                                "row-class": (row, index) =>
                                  row.paymentOrigin === "s/i" && "origin-other",
                              },
                              on: {
                                "page-change": function ($event) {
                                  return _vm.$emit("update:currentPage", $event)
                                },
                              },
                            },
                            _vm._l(_vm.tableHeaders, function (column, index) {
                              return _c("b-table-column", {
                                key: index,
                                attrs: {
                                  label: column.title,
                                  visible: column.visible,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (props) {
                                        return [
                                          column.field !== "paymentOrigin" &&
                                          column.field !== "isPaid"
                                            ? _c(
                                                "p",
                                                {
                                                  class: _vm.tableCellClasses(
                                                    props.row,
                                                    column.field
                                                  ),
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.row[column.field]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "b-tooltip",
                                                {
                                                  attrs: {
                                                    label: `${
                                                      props.row[column.field]
                                                    }${
                                                      props.row.isBalanced
                                                        ? ""
                                                        : ` (desbalanceado ${props.row.calculatedTotalMonthlyPayment})`
                                                    }${
                                                      props.row
                                                        .isBalanceConsistant
                                                        ? ""
                                                        : ` (inconsistente ${props.row.calculatedBalance})`
                                                    }`,
                                                    type: "is-light",
                                                    position: "is-right",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa-solid fa-circle ml-4",
                                                    class:
                                                      _vm.getClassForStatus(
                                                        props.row[column.field],
                                                        props.row.isBalanced,
                                                        props.row
                                                          .isBalanceConsistant
                                                      ),
                                                  }),
                                                ]
                                              ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }